<template>
  <Head title="Insights - Chart Builder" />
  
  <AppLayout>
    <div class="container-fluid">
      <div class="row justify-content-center mx-4">
        <div class="col p-0"> 
          <chart-builder 
            :chart="chart" 
            :metrics_filters="metrics_filters" 
            :clients="clients"
            :data_blends="data_blends"
          ></chart-builder>
        </div>
      </div>
    </div>
  </AppLayout>
</template>

<script setup>
import { Head } from '@inertiajs/vue3';
import AppLayout from '../../../Layouts/AppLayout.vue';

defineProps({
  chart: Object,
  metrics_filters: Array,
  clients: Array,
  data_blends: Array
});
</script>

